module.exports = __webpack_public_path__ + "static/aloopforms-a2de76fc1151dfcdf69adc4aabcb5407.png";